import React from "react";
import dayjs from "dayjs";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

/**
 * Dual-line payments comparison chart
 * @param {Array} expectedData - [{ date: '2025-10-01', expectedPayments: 3 }, ...]
 * @param {Array} receivedData - [{ date: '2025-10-01', receivedPayments: 2 }, ...]
 */
const LineGraphComponent = ({ expectedData = [], receivedData = [] }) => {
  // Step 1: Merge both arrays by date into a single dataset
  const dataMap = {};

  expectedData.forEach(({ date, expectedPayments }) => {
    dataMap[date] = { date, expectedPayments, receivedPayments: 0 };
  });

  receivedData.forEach(({ date, receivedPayments }) => {
    if (!dataMap[date])
      dataMap[date] = { date, expectedPayments: 0, receivedPayments: 0 };
    dataMap[date].receivedPayments = receivedPayments;
  });

  const mergedData = Object.values(dataMap).sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  // Step 2: Format date labels as "Oct 1"
  const formatDateLabel = (dateStr) => dayjs(dateStr).format("MMM D");

  // Step 3: Render responsive dual-line chart
  return (
    <div>
      <h4>
        Expected vs Received Payments
      </h4>
      
      <ResponsiveContainer width="100%" height={450}>
        <LineChart data={mergedData} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateLabel}
            tick={{ fontSize: 13 }}
          />
          <YAxis />
          <Tooltip
            labelFormatter={(label) => `Date: ${formatDateLabel(label)}`}
            contentStyle={{
              backgroundColor: "#ffffff",
              border: "1px solid #ddd",
              borderRadius: "8px",
              marginBottom:'8px'
            }}
          />
          <br></br>
          <Legend verticalAlign="top" height={36} />
          <Line
            type="monotone"
            dataKey="expectedPayments"
            stroke="#8884d8"
            strokeWidth={2}
            name="Expected Payments"
            dot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="receivedPayments"
            stroke="#82ca9d"
            strokeWidth={2}
            name="Received Payments"
            dot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineGraphComponent;
